<div class="booble-backdrop">
    <div class="booble-modal">
        <div class=" xp-modal xp-modal-cadastro">
            <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="icon"><img src="./assets/image/icon-m-global-sec.png"></div>
                        <div class="col-md-12">
                            <div class="header-title">Bem-vindo ao Novo Portal Oz Câmbio!</div>
                        </div>
                        <button type="button" (click)="closeModal()" class="btn-close" data-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="modal-dialog-scrollable-general">
                            <div>
                                <p>Entre em contato com um de nossos consultores para maior auxílio! (11) 91066-0459</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
